import styled from "styled-components";
import { fonts, header, transition } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const Title = styled.div`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 45px;
  line-height: 45px;
  margin-bottom: 24px;
  ${breakpoints.smDown} {
    font-size: 40px;
    line-height: 40px;
    margin-bottom: 16px;
  }
`;

export const ContentWrapper = styled.div<{ topPadding: string }>`
  padding-right: 15px;
  padding-left: 15px;
  padding-top: ${(props) => props.topPadding};
`;

export const CharacteristicDropdownsWrapper = styled.div`
  padding: 0 15px 24px 14px;
  max-width: 500px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

export const FullPageContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  ${breakpoints.smUp} {
    padding-right: 80px;
  }
  ${breakpoints.smDown} {
    padding-right: 0px;
  }
`;

export const ColumnContainer = styled.div`
  position: relative;
  width: 100%;
  align-items: flex-start;
  ${breakpoints.smUp} {
    display: flex;
  }
  ${breakpoints.smDown} {
    overflow-y: scroll;
  }
`;

export const LeftColumn = styled.div<{ isTopOffSetEqualToHeader: boolean }>`
  position: relative;
  ${breakpoints.smUp} {
    position: sticky;
    width: 50%;
    left: 0;
    top: ${(props) => (props.isTopOffSetEqualToHeader ? header.mobileHeight : "0px")};
  }
  width: 100%;
  ${breakpoints.mdUp} {
    top: ${(props) => (props.isTopOffSetEqualToHeader ? header.desktopHeight : "0px")};
  }
  transition: ${transition.headerMenuBarTransition};
`;

export const ImageGalleryHolder = styled.div`
  height: auto;
  width: 100%;
  align-items: center;
  overflow: hidden;
  ${breakpoints.smDown} {
    height: auto;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${breakpoints.smUp} {
    width: 50%;
    padding-left: 65px;
  }
  width: 100%;
  padding-bottom: 50px;
`;
